import { render, staticRenderFns } from "./TasksTabColsBodySlot.vue?vue&type=template&id=5b3c5310&"
import script from "./TasksTabColsBodySlot.vue?vue&type=script&lang=js&"
export * from "./TasksTabColsBodySlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTd,QTooltip,QIcon,QCardSection} from 'quasar'
component.options.components = Object.assign({QTd,QTooltip,QIcon,QCardSection}, component.options.components || {})
